import { useMemo } from 'react'
import { useActiveManagementApi } from '@/hooks/useApi/useActiveManagementApi/useActiveManagementApi'
import { mapActiveManagementTimezonesQueryParams } from '@/features/ActiveManagement/utils/mapActiveManagementTimezonesQueryParams'
import { useActiveManagementFiltersStore } from '@/features/ActiveManagement/stores/useActiveManagementFiltersStore'
import { type GetTimezonesRequestParams } from '@/hooks/useApi/useActiveManagementApi/types'
import useFiltersStore from '@/hooks/useFiltersStore/useFiltersStore'

export const useActiveManagementTimezonesQuery = () => {
    const activeFilters = useActiveManagementFiltersStore(
        (state) => state.activeFilters
    )
    const rootNode = useFiltersStore((state) => state.rootNode)
    const { useTimezonesQuery } = useActiveManagementApi()

    const timezonesQueryParams = useMemo<GetTimezonesRequestParams>(() => {
        let nodeIds: number[] = []
        if (activeFilters.node.length) {
            nodeIds = activeFilters.node
        } else if (rootNode) {
            nodeIds = [rootNode.nodeId]
        }
        return mapActiveManagementTimezonesQueryParams({
            facility: activeFilters.facility,
            tag: activeFilters.tag,
            node: nodeIds,
        })
    }, [
        activeFilters.facility,
        activeFilters.tag,
        activeFilters.node,
        rootNode,
    ])

    return useTimezonesQuery(timezonesQueryParams)
}
